import {FlatTreeControl} from "@angular/cdk/tree";
import {NzTreeFlatDataSource, NzTreeFlattener} from "ng-zorro-antd/tree-view";

export interface TreeNode {
  id: number|string,
  name: string;
  disabled?: boolean;
  children?: any[];
  level?: number;
  expand?: boolean;
  key: string;
  title: string;
  isLeaf?: boolean;
  parentKey?: number|string;
}

export interface FlatNode {
  expandable: boolean;
  name: string;
  level: number;
  disabled: boolean;
  data?: any;
  key: string;
  title: string;
}

export abstract class TreeViewComponent<T extends TreeNode, F extends FlatNode> {
  private transformer = (node: T, level: number): FlatNode => {
    node.title = node.name;
    node.key = node.id.toString();
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level,
      disabled: !!node.disabled,
      data: node,
      title: node.name,
      key: node.id.toString()
  }};

  treeControl = new FlatTreeControl<F>(
    node => node.level,
    node => node.expandable
  );

  treeFlattener = new NzTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => (node as T).children
  );

  // @ts-ignore
  dataSource = new NzTreeFlatDataSource(this.treeControl, this.treeFlattener);
  protected constructor(treeData: T[], isExpandAll: boolean = false) {
    this.dataSource.setData(treeData);
    isExpandAll ? this.treeControl.expandAll() : ()=>{};
  }

  hasChild = (_: number, node: F): boolean => node.expandable;

}

export abstract class TableTreeView<T extends TreeNode> {
  mapOfExpandedData :{[key: string]: T[]} = {};
  public data: T[];

  public key: string = "id";


  setData(data: T[]) { this.data = [...data]}
  setKeyName(keyName: string) {this.key = keyName;}

  public collapse(array: T[], data: T, $event: boolean) {
    if ($event) {
      if (data.children) {
        data.children.forEach(d => {
          const  target = array.find(a => a[this.key] === d[this.key])!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return
      }
    }
  }

  convertTreeToList(root: T): T[] {
    const stack: T[] = [];
    const array: T[] = [];
    const hashMap = {};
    stack.push({ ...root, level: 0, expand: false });

    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({ ...node.children[i], level: node.level! + 1, expand: false, parent: node });
        }
      }
    }

    return array;
  }

  visitNode(node: T, hashMap: { [key: string]: boolean }, array: T[]): void {
    if (!hashMap[node[this.key]]) {
      hashMap[node[this.key]] = true;
      array.push(node);
    }
  }

  public transform() {
    this.data.forEach(item => {
      this.mapOfExpandedData[item[this.key]] = this.convertTreeToList(item);
    })
  }
}
